export default "https://studio-ui-deployments.apollographql.com/build/static/assets/smb_powerup.1c8dc5764f0e9d3dda07980c1e70ca18.wav";